import React, { useState, useEffect } from 'react';
import { Search as SearchInput, Button, Modal, Typography } from '@telus-uds/components-web';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import FileDownload from 'js-file-download';
import FMFilters from '../../filters/fmFilters';
import request, { apiHost, config as axiosConfig } from '../../utils/request';
import { ContentWrapper, Box } from '../../design/css';
import { Search, TableBottomBar } from './css';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import Table from '../../design/shared/table';
import { OrderListModel } from './models';
import ValidateLoader from '../../UI/validateLoader';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {orderStatus } from '../../utils/constant';
import { getStatusFiltersPayload } from './utils';
import MessageNotification from '../../messageNotification';
import stringInterpolation from '../../utils/stringInterpolation';
import { useLocaleContext } from '../../context/LocaleContext';
import { getFormattedDate } from '../../utils/utils';
import View from './components/view';
import DiscountCalculator from './components/discountCalculator';
import { ExportOrdersModal } from '../dashboardCommon';
import { ChannelModel, getOptions } from '../../orders/models';
import useDashboardRequest from '../dashboardCommon/useDashboardRequest';

const ordersConnectionKey = 'ORDERS';

const initialFilterState = {
  startDate: null,
  endDate: null,
  completedStartDate: null,
  completedEndDate: null,
  status: [],
  submitter: [],
  channelId: []
};

const discountApprovalDashboardFM = ({ location: { search }, userId, selectedDiscount }) => {
  const local = useLocaleContext();
  const {
    srtDashboardFM: {
      FMLandingPage: { searchLabel, searchHint },
      confirmationDialog,
      noOrders,
      loadingMessage,
      confirm,
      cancel,
      confirmationMessage,
      manage,
      successActionMessage,
      statusesForDA,
      headerDiscountApproval
    }
  } = local === 'en-US' ? EN : FR;

  const localizedStrings = useLocalizedStringsContext();
  const staticLabelsForFilters = localizedStrings[ordersConnectionKey];
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { provinces } = userProfile;

  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [searchString, setSearchString] = useState(q);
  const [appliedSearch, setAppliedSearch] = useState(q || '');
  const [filterState, setFilterState] = useState(initialFilterState);
  const [filters, setFilters] = useState(''); // Initialize with initial filters
  const { loading, error: loadError, runRequest } = useDashboardRequest();
  const [order, setOrder] = useState({});
  const [data, setData] = useState();
  const [action, setAction] = useState();
  const [submitters, setSubmitters] = useState(null);
  const [channels, setChannels] = useState(null);
  const [isOrderUpdated, setOrderUpdated] = useState();
  const [message, setMessage] = useState('has been successfully updated');
  const [exportingOrders, setExportingOrders] = useState(false);
  const [isExportPopupVisible, setExportPopupVisible] = useState(false);

  const SrtPage = q ? 1 : localStorage.getItem('discountOrderPageNo')
    ? localStorage.getItem('discountOrderPageNo')
    : 1;
  const [srtPage, setSrtPage] = useState(SrtPage);
  const [tableHeaders, setTableHeaders] = useState(headerDiscountApproval);
  const { page } = queryString.parse(search);
  const pageSize = 50;

  const filterData = {
    statuses: statusesForDA,
    submitters,
    channels
  };
  useEffect(() => {
    setTableHeaders(headerDiscountApproval);
  }, [local]);

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
  };

  const resetFilters = () => {
    setSrtPage(1); // reset state of page number to page = 1
    const resetState = { ...initialFilterState, status: [] }; // Clear status on reset
    setFilterState(resetState);
    setFilters('');
    setSearchString('');
    setAppliedSearch('');
    localStorage.setItem('discountOrderPageNo', 1);
    history.push({ search: '' });
    if (srtPage === 1 && !filters && !appliedSearch) fetchData();
  };

  const fetchData = () => {
    const pagination = `pageNumber=${srtPage || 1}&pageSize=${pageSize}`;
    return runRequest(
      () => filters && !appliedSearch
        ? request.post(`/discounts/filter?${pagination}`, filters)
        : request.get(`/discounts?${pagination}&${queryString.stringify({ q: appliedSearch })}`),
      ordersResp => {
        const { results, totalCount } = ordersResp.data;
        setData({
          orders: results,
          count: totalCount
        });
      }
    );
  };

  const fetchFiltersData = async () => {
    return request
      .get('/get-wln-filters')
      .then(response => {
        setSubmitters(_.get(response, 'data.usersList', 0));
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
      })
      .catch(() => {});
  };

  const cancelOrder = () => {
    request
      .put(`/orders/${order.id}`, { status: 'ORDER_CANCELED' })
      .then(() => {
        setOrder({ ...order, open: false, isUpdated: true });
        fetchData();
      });
  };

  const getRedirectUrl = (row, formName) => {
    let steps;
    if (row.status === orderStatus.SendBacktoAccountManager) {
      steps = 1;
    } else {
      steps = row.step;
    }
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=${steps}&isEditing=true`
    });
    window.location.reload();
  };

  const getFilterPayload = () => {
    const payload = {
      ...filterState,
      submittedBy:
        filterState.submitter.length && filterState.submitter[0].value,
        channelId: filterState.channelId.map(row => row.value)
    };

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    if (filterState.completedStartDate)
      payload.completedStartDate = getFormattedDate(
        filterState.completedStartDate
      );
    if (filterState.completedEndDate)
      payload.completedEndDate = getFormattedDate(filterState.completedEndDate);
    return payload;
  };

  const getFilterParams = payload => {
    let allFilterParamsArray = {};

    if (payload.status && payload.status.length) {
      const { status } = getStatusFiltersPayload(payload.status);
      if (status.length) allFilterParamsArray.status = status;
    }
    if (payload.startDate) {
      allFilterParamsArray.startDate = payload.startDate;
    }
    if (payload.endDate) {
      allFilterParamsArray.endDate = payload.endDate;
    }
    if (payload.completedStartDate) {
      allFilterParamsArray.completedStartDate = payload.completedStartDate;
    }
    if (payload.completedEndDate) {
      allFilterParamsArray.completedEndDate = payload.completedEndDate;
    }
    if (payload.submitter && payload.submitter.length) {
      allFilterParamsArray.submitter = payload.submitter.map(
        (n, index) => n.value
      );
    }
    if (payload.channelId && payload.channelId.length) {
      allFilterParamsArray.channelId = payload.channelId.map((n, index) => n);
    }
    return allFilterParamsArray;
  };

  const hideExportPopup = () => {
    setExportPopupVisible(false);
  };

  const onExportOrders = type => {
    setExportingOrders(true);
    const endDate = moment(new Date()).format('YYYY-MM-DD');
    const startDate = moment(new Date())
      .subtract(3, 'month')
      .format('YYYY-MM-DD');
    let exportPayload = {
      filterCriteria: 'createdAt',
      startDate: startDate,
      endDate: endDate
    };
    if (type !== 'all') {
      const payload = getFilterPayload();
      exportPayload = { ...getFilterParams(payload) };
    }

    const exportUrl = `${apiHost}/discounts/export`;
    axios
      .post(
        exportUrl,
        { ...exportPayload },
        { responseType: 'arraybuffer', ...axiosConfig() }
      )
      .then(response => response.data)
      .then(fileData => {
        FileDownload(fileData, 'discountApproval.xlsx');
        setExportingOrders(false);
      })
      .catch(() => {});
  };

  const showExportPopup = () => {
    setExportPopupVisible(true);
  };

  const applyFilters = () => {
    setSrtPage(1);
    localStorage.setItem('discountOrderPageNo', 1);
    setAppliedSearch('');
    setSearchString('');
    setFilters(getFilterParams(getFilterPayload()));
  };

  const onSave = value => {
    setMessage('has been successfully updated');
    window.scrollTo(0, 0);
    setOrderUpdated(value);
  };

  const onConfirm = () => {
    switch (action) {
      case continueAction:
        getRedirectUrl(order.orderDetails, fullyManagedForm);
        break;
      case cancelAction:
        cancelOrder();
        break;
      default:
    }
  };

  const getActions = row => {
    const orderData = row;
    const actions = (
      <>
        <DiscountCalculator
          discountData={orderData}
          onSave={onSave}
          fetchData={fetchData}
        />
      </>
    );
    return actions;
  };

  const onSearchClick = () => {
    const nextSearch = (searchString || '').trim();
    setSrtPage(1);
    localStorage.setItem('discountOrderPageNo', 1);
    setAppliedSearch(nextSearch);
    setFilters('');
    history.push({
      search: `?${queryString.stringify({ q: nextSearch })}`
    });
    if (srtPage === 1 && appliedSearch === nextSearch && !filters) fetchData();
  };

  const onClear = () => {
    setSearchString('');
    setAppliedSearch('');
    setSrtPage(1);
    localStorage.setItem('discountOrderPageNo', 1);
    history.push({
      search: ''
    });
  };

  useEffect(() => {
    fetchFiltersData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [srtPage, appliedSearch, filters, isOrderUpdated]);

  return (
    <>
      <div style={{ padding: '0 6rem' }}>
        <FMFilters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={staticLabelsForFilters}
          isDiscountOrder={true}
        />
        <Search>
          <div></div>
          <div style={{ marginLeft: 20 }}>
            <SearchInput
              placeholder={searchHint || searchLabel}
              value={searchString || ''}
              onClear={() => onClear()}
              onChange={setSearchString}
              onSubmit={() => onSearchClick()}
            />
          </div>
        </Search>
      </div>
      {isOrderUpdated && isOrderUpdated.isUpdated && (
        <Box top={4} bottom={4}>
          <MessageNotification
            variant={{ validation: 'success' }}
            message={`${'Order with Order ID:'}${
              isOrderUpdated.orderId
            } ${message}`}
          />
        </Box>
      )}
      <ContentWrapper>
        {loadError && (
          <MessageNotification variant="error" message={staticLabelsForFilters.LOAD_ERROR} />
        )}
        {loading ? (
          <ValidateLoader message={loadingMessage} />
        ) : (
          <>
            {order && order.isUpdated && (
              <Box top={4} bottom={4}>
                <MessageNotification
                  variant={{ validation: 'success' }}
                  message={stringInterpolation(
                    successActionMessage,
                    action,
                    order.orderId
                  )}
                />
              </Box>
            )}
            {data && data.orders && data.orders.length ? (
              <>
                <Table
                  title={manage}
                  header={tableHeaders}
                  data={data.orders}
                  actions={getActions}
                  dataModel={OrderListModel}
                  currentPage={parseInt(srtPage || 1, 10)}
                  setSrtPage={setSrtPage}
                  count={data.count}
                  actionsDisplay="grid"
                  step={pageSize}
                />
              </>
            ) : (
              !loadError && <div style={{ textAlign: 'center' }}><Typography block>{noOrders}</Typography></div>
            )}
            <TableBottomBar>
              <Button onClick={showExportPopup}>Export Orders</Button>
            </TableBottomBar>
          </>
        )}
        {
          <Modal
            heading={confirmationDialog}
            bodyText={`${confirmationMessage} ${action} ?`}
            confirmButtonText={confirm}
            cancelButtonText={cancel}
            onConfirm={() => onConfirm()}
            onClose={() => setOrder({ ...order, open: false })}
            isOpen={action && order.open}
          />
        }
      </ContentWrapper>
      <ExportOrdersModal
        isLoading={exportingOrders}
        onExportOrders={onExportOrders}
        isVisible={isExportPopupVisible}
        onClose={hideExportPopup}
      />
    </>
  );
};

discountApprovalDashboardFM.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  selectedDiscount: PropTypes.number
};

export default discountApprovalDashboardFM;
